// Global 401 handler: clears auth state and redirects to /login on expired/invalid tokens.
import axios from 'axios';
import store from './store';
import router from './router';

const PRE_AUTH_ENDPOINTS = [
  '/v2/login',
  '/v2/password-forgot',
  '/v2/password-reset',
  '/v2/register',
  '/role',
];

export function setupInterceptors() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response) {
        return Promise.reject(error);
      }

      if (error.response.status !== 401) {
        return Promise.reject(error);
      }

      const url = error.config && error.config.url ? error.config.url : '';
      const isPreAuth = PRE_AUTH_ENDPOINTS.some((endpoint) => url.includes(endpoint));
      if (isPreAuth) {
        return Promise.reject(error);
      }

      localStorage.removeItem('user_free');
      store.commit('auth/isLoggedIn', false);

      if (router.currentRoute.value.path !== '/login') {
        router.push('/login');
      }

      return Promise.reject(error);
    }
  );
}
